var _rect, _g, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumingLogoFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 274,
    viewBox: "0 0 274 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 274,
    rx: 26,
    fill: "#F3F5F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii_887_2314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1217 95.1169C91.1217 92.9077 89.3308 91.1169 87.1217 91.1169H76.2437C74.0346 91.1169 72.2437 92.9077 72.2437 95.1169V117.318C72.2437 119.527 70.4529 121.318 68.2437 121.318H46.878C44.6688 121.318 42.878 119.527 42.878 117.318V94.6713C42.878 92.5524 41.2215 90.8167 39.1119 91.0147C33.6043 91.5315 24 93.8926 24 104.076V164.205C24 166.414 25.7909 168.212 28 168.212H38.878C41.0871 168.212 42.878 166.421 42.878 164.212V139.662C42.878 137.796 44.1676 136.179 45.9862 135.763L48.8326 135.112C50.8863 134.642 53.0824 135.81 54.2039 137.593C55.2927 139.324 57.031 141.733 59.7688 144.82C63.0273 148.494 66.2876 150.367 68.6575 151.319C70.6065 152.101 72.2437 153.916 72.2437 156.016V164.212C72.2437 166.421 74.0346 168.212 76.2437 168.212H87.1217C89.3308 168.212 91.1217 166.421 91.1217 164.212V151.412C89.5027 151.05 87.7674 150.824 85.912 150.768C68.2665 150.244 63.1199 147.727 55.2425 133.883C54.5072 132.274 48.2893 128.408 29.2994 125.807C33.4657 125.842 43.8779 126.73 52.1965 130.002C52.6867 130.177 53.856 130.359 54.6123 129.687C54.8514 129.475 55.1242 129.075 55.451 128.595C56.4159 127.179 57.8518 125.073 60.284 125.073C63.54 125.073 65.8508 126.96 66.7961 130.422C69.772 130.841 76.7952 131.072 81.0805 128.639C83.5868 127.215 87.4036 124.736 91.1217 121.717V95.1169ZM91.1217 131.285C88.7355 133.824 85.839 136.313 82.3409 138.602C79.9602 139.791 77.3413 142.609 85.912 144.371C87.3765 144.789 89.1765 145.445 91.1217 146.345V131.285ZM76.354 128.639C74.7277 128.918 70.9593 129.436 68.8967 129.268C71.3825 124.443 77.4254 113.934 81.7107 110.494C80.6691 112.791 78.9579 117.051 77.7471 121.297C77.0043 123.902 76.4499 126.501 76.354 128.639Z",
    fill: "#272727"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_887_2314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3401 137.118C91.6353 135.104 99.7307 118.233 101.366 110.049C101.227 115.505 97.2527 128.851 82.468 138.587C80.1014 139.776 77.498 142.595 86.018 144.357C74.8251 144.609 72.2357 139.636 72.3401 137.118Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.736 182.337C111.745 172.937 106.552 163.872 103.455 160.515C105.794 166.138 104.012 171.041 102.828 172.79L105.282 177.564L107.736 182.337Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7901 129.203C70.8405 129.371 74.8998 128.899 76.5166 128.62C76.6119 126.481 77.163 123.881 77.9014 121.275C76.5697 123.129 72.6325 127.272 68.7901 129.203Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7528 128.268C86.3304 125.775 97.8165 117.708 101.366 110.049M101.366 110.049C99.7307 118.233 91.6353 135.104 72.3401 137.118C72.2357 139.636 74.8251 144.609 86.018 144.357M101.366 110.049C101.227 115.505 97.2527 128.851 82.468 138.587C80.1014 139.776 77.498 142.595 86.018 144.357M86.018 144.357C92.8396 146.316 106.984 153.506 108.989 166.6C107.179 161.494 99.1723 151.014 86.0172 151.014M103.455 160.515C106.552 163.872 111.745 172.937 107.736 182.337L105.282 177.564M103.455 160.515C105.794 166.138 104.012 171.041 102.828 172.79L105.282 177.564M103.455 160.515C105.195 163.802 107.997 171.814 105.282 177.564M76.5166 128.62C74.8998 128.899 70.8405 129.371 68.7901 129.203C72.6325 127.272 76.5697 123.129 77.9014 121.275C77.163 123.881 76.6119 126.481 76.5166 128.62Z",
    stroke: "#272727",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddii_887_2314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.869 124.163V147.499H118.528V144.321C117.784 145.352 116.768 146.189 115.48 146.83C114.221 147.443 112.818 147.75 111.273 147.75C109.441 147.75 107.824 147.36 106.422 146.579C105.019 145.77 103.932 144.613 103.159 143.108C102.386 141.602 102 139.832 102 137.796V124.163H109.298V136.835C109.298 138.396 109.713 139.609 110.543 140.473C111.373 141.337 112.489 141.77 113.891 141.77C115.322 141.77 116.453 141.337 117.283 140.473C118.113 139.609 118.528 138.396 118.528 136.835V124.163H125.869Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.707 123.912C164.684 123.912 167.045 124.79 168.791 126.546C170.565 128.303 171.452 130.743 171.452 133.865V147.499H164.154V134.827C164.154 133.322 163.739 132.164 162.909 131.356C162.108 130.52 160.992 130.101 159.561 130.101C158.13 130.101 156.999 130.52 156.169 131.356C155.368 132.164 154.967 133.322 154.967 134.827V147.499H147.669V134.827C147.669 133.322 147.254 132.164 146.425 131.356C145.623 130.52 144.507 130.101 143.076 130.101C141.645 130.101 140.515 130.52 139.685 131.356C138.883 132.164 138.483 133.322 138.483 134.827V147.499H131.142V124.163H138.483V127.09C139.227 126.114 140.2 125.348 141.402 124.79C142.604 124.204 143.963 123.912 145.48 123.912C147.283 123.912 148.886 124.288 150.288 125.041C151.719 125.794 152.835 126.867 153.637 128.261C154.467 126.979 155.597 125.933 157.028 125.125C158.459 124.316 160.019 123.912 161.707 123.912Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.278 121.737C178.99 121.737 177.932 121.375 177.102 120.65C176.3 119.897 175.9 118.977 175.9 117.889C175.9 116.774 176.3 115.854 177.102 115.129C177.932 114.376 178.99 114 180.278 114C181.538 114 182.568 114.376 183.369 115.129C184.199 115.854 184.614 116.774 184.614 117.889C184.614 118.977 184.199 119.897 183.369 120.65C182.568 121.375 181.538 121.737 180.278 121.737ZM183.927 124.163V147.499H176.586V124.163H183.927Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.843 123.912C206.648 123.912 208.88 124.804 210.54 126.588C212.229 128.345 213.073 130.77 213.073 133.865V147.499H205.775V134.827C205.775 133.266 205.36 132.053 204.53 131.189C203.7 130.324 202.584 129.892 201.182 129.892C199.779 129.892 198.663 130.324 197.833 131.189C197.003 132.053 196.588 133.266 196.588 134.827V147.499H189.247V124.163H196.588V127.257C197.332 126.226 198.334 125.417 199.593 124.832C200.852 124.218 202.269 123.912 203.843 123.912Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.869 124.163V147.499H118.528V144.321C117.784 145.352 116.768 146.189 115.48 146.83C114.221 147.443 112.818 147.75 111.273 147.75C109.441 147.75 107.824 147.36 106.422 146.579C105.019 145.77 103.932 144.613 103.159 143.108C102.386 141.602 102 139.832 102 137.796V124.163H109.298V136.835C109.298 138.396 109.713 139.609 110.543 140.473C111.373 141.337 112.489 141.77 113.891 141.77C115.322 141.77 116.453 141.337 117.283 140.473C118.113 139.609 118.528 138.396 118.528 136.835V124.163H125.869Z",
    stroke: "black",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.869 124.163V147.499H118.528V144.321C117.784 145.352 116.768 146.189 115.48 146.83C114.221 147.443 112.818 147.75 111.273 147.75C109.441 147.75 107.824 147.36 106.422 146.579C105.019 145.77 103.932 144.613 103.159 143.108C102.386 141.602 102 139.832 102 137.796V124.163H109.298V136.835C109.298 138.396 109.713 139.609 110.543 140.473C111.373 141.337 112.489 141.77 113.891 141.77C115.322 141.77 116.453 141.337 117.283 140.473C118.113 139.609 118.528 138.396 118.528 136.835V124.163H125.869Z",
    stroke: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.707 123.912C164.684 123.912 167.045 124.79 168.791 126.546C170.565 128.303 171.452 130.743 171.452 133.865V147.499H164.154V134.827C164.154 133.322 163.739 132.164 162.909 131.356C162.108 130.52 160.992 130.101 159.561 130.101C158.13 130.101 156.999 130.52 156.169 131.356C155.368 132.164 154.967 133.322 154.967 134.827V147.499H147.669V134.827C147.669 133.322 147.254 132.164 146.425 131.356C145.623 130.52 144.507 130.101 143.076 130.101C141.645 130.101 140.515 130.52 139.685 131.356C138.883 132.164 138.483 133.322 138.483 134.827V147.499H131.142V124.163H138.483V127.09C139.227 126.114 140.2 125.348 141.402 124.79C142.604 124.204 143.963 123.912 145.48 123.912C147.283 123.912 148.886 124.288 150.288 125.041C151.719 125.794 152.835 126.867 153.637 128.261C154.467 126.979 155.597 125.933 157.028 125.125C158.459 124.316 160.019 123.912 161.707 123.912Z",
    stroke: "black",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.707 123.912C164.684 123.912 167.045 124.79 168.791 126.546C170.565 128.303 171.452 130.743 171.452 133.865V147.499H164.154V134.827C164.154 133.322 163.739 132.164 162.909 131.356C162.108 130.52 160.992 130.101 159.561 130.101C158.13 130.101 156.999 130.52 156.169 131.356C155.368 132.164 154.967 133.322 154.967 134.827V147.499H147.669V134.827C147.669 133.322 147.254 132.164 146.425 131.356C145.623 130.52 144.507 130.101 143.076 130.101C141.645 130.101 140.515 130.52 139.685 131.356C138.883 132.164 138.483 133.322 138.483 134.827V147.499H131.142V124.163H138.483V127.09C139.227 126.114 140.2 125.348 141.402 124.79C142.604 124.204 143.963 123.912 145.48 123.912C147.283 123.912 148.886 124.288 150.288 125.041C151.719 125.794 152.835 126.867 153.637 128.261C154.467 126.979 155.597 125.933 157.028 125.125C158.459 124.316 160.019 123.912 161.707 123.912Z",
    stroke: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.278 121.737C178.99 121.737 177.932 121.375 177.102 120.65C176.3 119.897 175.9 118.977 175.9 117.889C175.9 116.774 176.3 115.854 177.102 115.129C177.932 114.376 178.99 114 180.278 114C181.538 114 182.568 114.376 183.369 115.129C184.199 115.854 184.614 116.774 184.614 117.889C184.614 118.977 184.199 119.897 183.369 120.65C182.568 121.375 181.538 121.737 180.278 121.737ZM183.927 124.163V147.499H176.586V124.163H183.927Z",
    stroke: "black",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.278 121.737C178.99 121.737 177.932 121.375 177.102 120.65C176.3 119.897 175.9 118.977 175.9 117.889C175.9 116.774 176.3 115.854 177.102 115.129C177.932 114.376 178.99 114 180.278 114C181.538 114 182.568 114.376 183.369 115.129C184.199 115.854 184.614 116.774 184.614 117.889C184.614 118.977 184.199 119.897 183.369 120.65C182.568 121.375 181.538 121.737 180.278 121.737ZM183.927 124.163V147.499H176.586V124.163H183.927Z",
    stroke: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.843 123.912C206.648 123.912 208.88 124.804 210.54 126.588C212.229 128.345 213.073 130.77 213.073 133.865V147.499H205.775V134.827C205.775 133.266 205.36 132.053 204.53 131.189C203.7 130.324 202.584 129.892 201.182 129.892C199.779 129.892 198.663 130.324 197.833 131.189C197.003 132.053 196.588 133.266 196.588 134.827V147.499H189.247V124.163H196.588V127.257C197.332 126.226 198.334 125.417 199.593 124.832C200.852 124.218 202.269 123.912 203.843 123.912Z",
    stroke: "black",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.843 123.912C206.648 123.912 208.88 124.804 210.54 126.588C212.229 128.345 213.073 130.77 213.073 133.865V147.499H205.775V134.827C205.775 133.266 205.36 132.053 204.53 131.189C203.7 130.324 202.584 129.892 201.182 129.892C199.779 129.892 198.663 130.324 197.833 131.189C197.003 132.053 196.588 133.266 196.588 134.827V147.499H189.247V124.163H196.588V127.257C197.332 126.226 198.334 125.417 199.593 124.832C200.852 124.218 202.269 123.912 203.843 123.912Z",
    stroke: "#272727"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddii_887_2314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.365 124C233.502 124 235.367 124.419 236.961 125.256C238.591 126.093 239.84 127.191 240.71 128.552V124.419H250V153.56C250 156.246 249.439 158.67 248.316 160.832C247.229 163.03 245.545 164.774 243.263 166.064C241.018 167.355 238.211 168 234.842 168C230.351 168 226.711 166.971 223.922 164.913C221.133 162.89 219.539 160.135 219.141 156.647H228.323C228.612 157.763 229.301 158.635 230.387 159.263C231.474 159.925 232.814 160.257 234.407 160.257C236.327 160.257 237.848 159.716 238.971 158.635C240.13 157.589 240.71 155.897 240.71 153.56V149.427C239.804 150.787 238.555 151.903 236.961 152.775C235.367 153.612 233.502 154.031 231.365 154.031C228.866 154.031 226.602 153.421 224.574 152.2C222.546 150.944 220.934 149.183 219.739 146.916C218.58 144.614 218 141.963 218 138.963C218 135.964 218.58 133.33 219.739 131.063C220.934 128.796 222.546 127.052 224.574 125.831C226.602 124.61 228.866 124 231.365 124ZM240.71 139.015C240.71 136.783 240.058 135.022 238.754 133.731C237.486 132.441 235.929 131.795 234.081 131.795C232.234 131.795 230.659 132.441 229.355 133.731C228.087 134.987 227.453 136.731 227.453 138.963C227.453 141.195 228.087 142.974 229.355 144.3C230.659 145.59 232.234 146.235 234.081 146.235C235.929 146.235 237.486 145.59 238.754 144.3C240.058 143.009 240.71 141.248 240.71 139.015Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.365 124C233.502 124 235.367 124.419 236.961 125.256C238.591 126.093 239.84 127.191 240.71 128.552V124.419H250V153.56C250 156.246 249.439 158.67 248.316 160.832C247.229 163.03 245.545 164.774 243.263 166.064C241.018 167.355 238.211 168 234.842 168C230.351 168 226.711 166.971 223.922 164.913C221.133 162.89 219.539 160.135 219.141 156.647H228.323C228.612 157.763 229.301 158.635 230.387 159.263C231.474 159.925 232.814 160.257 234.407 160.257C236.327 160.257 237.848 159.716 238.971 158.635C240.13 157.589 240.71 155.897 240.71 153.56V149.427C239.804 150.787 238.555 151.903 236.961 152.775C235.367 153.612 233.502 154.031 231.365 154.031C228.866 154.031 226.602 153.421 224.574 152.2C222.546 150.944 220.934 149.183 219.739 146.916C218.58 144.614 218 141.963 218 138.963C218 135.964 218.58 133.33 219.739 131.063C220.934 128.796 222.546 127.052 224.574 125.831C226.602 124.61 228.866 124 231.365 124ZM240.71 139.015C240.71 136.783 240.058 135.022 238.754 133.731C237.486 132.441 235.929 131.795 234.081 131.795C232.234 131.795 230.659 132.441 229.355 133.731C228.087 134.987 227.453 136.731 227.453 138.963C227.453 141.195 228.087 142.974 229.355 144.3C230.659 145.59 232.234 146.235 234.081 146.235C235.929 146.235 237.486 145.59 238.754 144.3C240.058 143.009 240.71 141.248 240.71 139.015Z",
    stroke: "black",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.365 124C233.502 124 235.367 124.419 236.961 125.256C238.591 126.093 239.84 127.191 240.71 128.552V124.419H250V153.56C250 156.246 249.439 158.67 248.316 160.832C247.229 163.03 245.545 164.774 243.263 166.064C241.018 167.355 238.211 168 234.842 168C230.351 168 226.711 166.971 223.922 164.913C221.133 162.89 219.539 160.135 219.141 156.647H228.323C228.612 157.763 229.301 158.635 230.387 159.263C231.474 159.925 232.814 160.257 234.407 160.257C236.327 160.257 237.848 159.716 238.971 158.635C240.13 157.589 240.71 155.897 240.71 153.56V149.427C239.804 150.787 238.555 151.903 236.961 152.775C235.367 153.612 233.502 154.031 231.365 154.031C228.866 154.031 226.602 153.421 224.574 152.2C222.546 150.944 220.934 149.183 219.739 146.916C218.58 144.614 218 141.963 218 138.963C218 135.964 218.58 133.33 219.739 131.063C220.934 128.796 222.546 127.052 224.574 125.831C226.602 124.61 228.866 124 231.365 124ZM240.71 139.015C240.71 136.783 240.058 135.022 238.754 133.731C237.486 132.441 235.929 131.795 234.081 131.795C232.234 131.795 230.659 132.441 229.355 133.731C228.087 134.987 227.453 136.731 227.453 138.963C227.453 141.195 228.087 142.974 229.355 144.3C230.659 145.59 232.234 146.235 234.081 146.235C235.929 146.235 237.486 145.59 238.754 144.3C240.058 143.009 240.71 141.248 240.71 139.015Z",
    stroke: "#272727"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ddii_887_2314)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 154,
    width: 103,
    height: 2,
    rx: 1,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 154.5,
    width: 102,
    height: 1,
    rx: 0.5,
    stroke: "black",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 154.5,
    width: 102,
    height: 1,
    rx: 0.5,
    stroke: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii_887_2314",
    x: 4,
    y: 70.9993,
    width: 99.1216,
    height: 109.213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.572549 0 0 0 0 0.72549 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_887_2314",
    result: "effect2_dropShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_887_2314",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462187 0 0 0 0 0.571159 0 0 0 0 0.725 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_887_2314",
    result: "effect4_innerShadow_887_2314"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_887_2314",
    x: 64.54,
    y: 109.799,
    width: 48.9053,
    height: 80.7881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_887_2314",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddii_887_2314",
    x: 81.5,
    y: 93.5,
    width: 144.073,
    height: 66.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.572549 0 0 0 0 0.72549 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_887_2314",
    result: "effect2_dropShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_887_2314",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462187 0 0 0 0 0.571159 0 0 0 0 0.725 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_887_2314",
    result: "effect4_innerShadow_887_2314"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddii_887_2314",
    x: 197.5,
    y: 103.5,
    width: 65,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.572549 0 0 0 0 0.72549 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_887_2314",
    result: "effect2_dropShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_887_2314",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462187 0 0 0 0 0.571159 0 0 0 0 0.725 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_887_2314",
    result: "effect4_innerShadow_887_2314"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ddii_887_2314",
    x: 91,
    y: 134,
    width: 135,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.572549 0 0 0 0 0.72549 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_887_2314",
    result: "effect2_dropShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_887_2314",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462187 0 0 0 0 0.571159 0 0 0 0 0.725 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_887_2314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_887_2314",
    result: "effect4_innerShadow_887_2314"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumingLogoFooter);
export default __webpack_public_path__ + "static/media/HumingLogoFooter.c8a663d2f0852378f78a5aaa3de095e1.svg";
export { ForwardRef as ReactComponent };